import { AFFILIATE_LIST, LOADING, NOT_FOUND } from "../action/type";

const initialState = {
  list: [{}],
  loading: false,
  not_found: false,
};
const affiliate = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, list: action.payload, loading: true, not_found: false };
    case NOT_FOUND:
      return { ...state, list: action.payload, loading: false, not_found: true };
    case AFFILIATE_LIST:
      return { ...state, list: action.payload, loading: false, not_found: false };
    default:
      return state;
  }
};

export default affiliate;
